import React from 'react';
import { Link } from 'react-router-dom';

const UserLink = ({ user }) => {
  let { role, firstName, lastName, legal, company } = user;
  let roleName = 'customer';
  !role && (role = ['customer']);
  role.includes('driver') && (roleName = 'driver');
  role.includes('freight') && (roleName = 'freight');
  role.includes('admin') && (roleName = 'admin');

  return (
    <Link to={`/protected/admin/users/${roleName}/${user._id}`}>
      {legal ? company : `${firstName} ${lastName} `}
    </Link>
  );
};

export default UserLink;
